// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.top-notification {
    left: 50%;
    transform: translate(-50%, -51px);
    will-change: transform;
}
.slide-bar-enter-active,
.slide-bar-leave-active {
    transition: transform 0.3s ease;
}
.slide-bar-enter-from,
.slide-bar-leave-to {
    transform: translate(-50%, 0);
}
.slide-bar-enter-to,
.slide-bar-leave-from {
    transform: translate(-50%, -51px);
}
`, "",{"version":3,"sources":["webpack://./src/scripts/sections/modals/_ModalHeader.vue"],"names":[],"mappings":";AA6FA;IACI,SAAS;IACT,iCAAiC;IACjC,sBAAsB;AAC1B;AAEA;;IAEI,+BAA+B;AACnC;AAEA;;IAEI,6BAA6B;AACjC;AAEA;;IAEI,iCAAiC;AACrC","sourcesContent":["\n.top-notification {\n    left: 50%;\n    transform: translate(-50%, -51px);\n    will-change: transform;\n}\n\n.slide-bar-enter-active,\n.slide-bar-leave-active {\n    transition: transform 0.3s ease;\n}\n\n.slide-bar-enter-from,\n.slide-bar-leave-to {\n    transform: translate(-50%, 0);\n}\n\n.slide-bar-enter-to,\n.slide-bar-leave-from {\n    transform: translate(-50%, -51px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
